import { Box, Button, Stack } from '@mui/material';
import { useState } from 'react';

const Multilang = () => {
  const [lang, setLang] = useState<string>('ENG');
  return (
    <Stack mr={1} direction="row" spacing={1}>
      <Box>
        <Button
          onClick={() => {
            setLang('KZ');
            // changeData(index);
          }}
          color={lang === 'KZ' ? 'primary' : 'secondary'}
          variant={lang === 'KZ' ? 'outlined' : 'text'}
          //   aria-label="open profile"
          //   aria-haspopup="true"
        >
          <img src="/icons/icon-kazakhstan.png" width={20} alt="" style={{ marginRight: '5px' }} />
          KZ
        </Button>
      </Box>

      <Box>
        <Button
          onClick={() => {
            setLang('RU');
            // changeData(index);
          }}
          color={lang === 'RU' ? 'primary' : 'secondary'}
          variant={lang === 'RU' ? 'outlined' : 'text'}
          //   aria-label="open profile"
          //   aria-haspopup="true"
        >
          <img src="/icons/icon-Russia.png" width={20} alt="" style={{ marginRight: '5px' }} />
          RU
        </Button>
      </Box>

      <Box>
        <Button
          onClick={() => {
            setLang('ENG');
            // changeData(index);
          }}
          color={lang === 'ENG' ? 'primary' : 'secondary'}
          variant={lang === 'ENG' ? 'outlined' : 'text'}
          //   aria-label="open profile"
          //   aria-haspopup="true"
        >
          <img src="/icons/icon-united-states.png" width={20} alt="" style={{ marginRight: '5px' }} />
          ENG
        </Button>
      </Box>
    </Stack>
  );
};

export default Multilang;
